import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import { withTranslation } from 'react-i18next';
import ui from '../../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

const List = ({ t, ...rest }) => {
	const columns = [
		{
			header: t('MonthlyPaymentReport_Id'),
			accessor: 'id',
			sortable: true
		},
		{
			header: t('MonthlyPaymentReport_Center'),
			accessor: 'center',
			sortable: true
		},
		{
			header: t('MonthlyPaymentReport_Parent'),
			accessor: 'parent',
			cell: (parent, row) => (<Link to={`/parents/${row.parentId}`} > {parent}</Link>),
			sortable: true
		},
		{
			header: t('MonthlyPaymentReport_Child'),
			accessor: 'child',
			sortable: true
		},
		{
			header: t('MonthlyPaymentReport_Status'),
			accessor: 'status',
			sortable: false
		},
		{
			header: t('MonthlyPaymentReport_PaymentDate'),
			accessor: 'paymentDate',
			sortable: true,
			cell: paymentDate => ui.formatDateTime(paymentDate)
		},
		{
			header: t('MonthlyPaymentReport_Quantity'),
			accessor: 'quantity',
			sortable: false
		},
		{
			header: t('MonthlyPaymentReport_UnitPrice'),
			accessor: 'unitPrice',
			cell: (unitPrice) => ui.formatAmount(unitPrice),
			sortable: false
		},
		{
			header: t('MonthlyPaymentReport_Total'),
			accessor: 'total',
			cell: (total) => ui.formatAmount(total),
			sortable: false
		},
		{
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, row) => (<div>
				<Link to={`/paymentHistory/${id}`} className='btn btn-teal'><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</Link>
			</div>)
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);